import { LegalComponent } from '@app/_v2/legal/legal.component';
import { PrivacyPolicyComponent } from '@app/_v2/legal/legals/privacy-policy.component';
import { BonusTermsComponent } from '@app/_v2/legal/legals/bonus-terms.component';
import { TermsAndConditionsComponent } from '@app/_v2/legal/legals/terms-and-conditions.component';
var ɵ0 = { allowChat: false }, ɵ1 = { title: 'Edgeless - Terms & Conditions' }, ɵ2 = { title: 'Edgeless - Terms & Conditions' }, ɵ3 = { title: 'Edgeless - Privacy Policy' }, ɵ4 = { title: 'Edgeless - Bonus terms' };
var routes = [
    {
        path: '',
        component: LegalComponent,
        data: ɵ0,
        children: [
            {
                path: '',
                component: TermsAndConditionsComponent,
                data: ɵ1,
            },
            {
                path: 'terms-and-conditions',
                component: TermsAndConditionsComponent,
                data: ɵ2,
            },
            {
                path: 'privacy-policy',
                component: PrivacyPolicyComponent,
                data: ɵ3,
            },
            {
                path: 'bonus-terms',
                component: BonusTermsComponent,
                data: ɵ4,
            },
        ],
    },
];
var LegalRoutingModule = /** @class */ (function () {
    function LegalRoutingModule() {
    }
    return LegalRoutingModule;
}());
export { LegalRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4 };



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/legal/legal-routing.module.ts.pre-build-optimizer.js